// extracted by mini-css-extract-plugin
export default {"root":"PersonalSettings_root__q7ZIt"};